import React from 'react';
import lang from './en-US';

const LangContext = React.createContext(lang); //default is en-US;
export default LangContext;